import { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { useLocale } from '../contexts/LocaleProvider';
import { IntlProvider } from 'react-intl';
import AutomotiveHome from './automotivePage/AutomotiveHome';
import { PrefilteredResourceLibraryItemsProvider } from '../graphql/pimcore/modules/resourceLibrary/contexts/PrefilteredResourceLibraryItemsProvider';
import { useApplicationsContent } from '../graphql/pimcore/modules/siteContent/hooks/useApplicationsContent';
import DebouncedLoader from './common/DebouncedLoader';

const AutomotivePage: FunctionComponent = () => {
    const { locale, messages } = useLocale();
    const { loading, error, contentTree } = useApplicationsContent('Automotive');

    if (error && !loading) {
        return <div className="mid-width">Error: {error.message}</div>;
    }

    return (
        <DebouncedLoader loading={loading} delay={1000} size={40} centered={true}>
            <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
                <PrefilteredResourceLibraryItemsProvider
                    initialFilters={{
                        productApplicationKeys: ['Automotive'],
                    }}
                >
                    <Box
                        width="100%"
                        component="main"
                        sx={{
                            padding: 0,
                            flexGrow: 0,
                            p: 0,
                        }}
                    >
                        <AutomotiveHome cmsContent={contentTree} />
                    </Box>
                </PrefilteredResourceLibraryItemsProvider>
            </IntlProvider>
        </DebouncedLoader>
    );
};
export default AutomotivePage;
